import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { CapabilityRoleService } from '@core/services/entities/capability-role.service';
import { CapabilityRoleResponseDto } from '@domain/capability-role/dtos/capability-role.response.dto';
import { CreateCapabilityRoleRequestDto } from '@domain/capability-role/dtos/create-capability-role.request.dto';
import { ListCapabilityRoleRequestDto } from '@domain/capability-role/dtos/list-capability-role.request.dto';
import { UpdateCapabilityRoleRequestDto } from '@domain/capability-role/dtos/update-capability-role.request.dto';
import { UpdateStateCapabilityRoleRequestDto } from '@domain/capability-role/dtos/update-state-capability-role.request.dto';
import { CapabilityRoleRepository } from '@domain/capability-role/repositories/capability-role.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CapabilityRoleRepositoryService
  implements CapabilityRoleRepository
{
  constructor(private capabilityRoleService: CapabilityRoleService) {}
  create(
    request: CreateCapabilityRoleRequestDto,
  ): Observable<ApiResponse<CapabilityRoleResponseDto>> {
    return this.capabilityRoleService.create(request);
  }
  update(
    request: UpdateCapabilityRoleRequestDto,
  ): Observable<ApiResponse<CapabilityRoleResponseDto>> {
    return this.capabilityRoleService.update(request);
  }
  updateState(
    request: UpdateStateCapabilityRoleRequestDto,
  ): Observable<ApiResponse<CapabilityRoleResponseDto>> {
    return this.capabilityRoleService.updateState(request);
  }
  show(request: RefId): Observable<ApiResponse<CapabilityRoleResponseDto>> {
    return this.capabilityRoleService.show(request);
  }
  list(
    request: ListCapabilityRoleRequestDto,
  ): Observable<ApiResponse<PageableResponse<CapabilityRoleResponseDto>>> {
    return this.capabilityRoleService.list(request);
  }
}
